import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls, MeshDistortMaterial, FirstPersonControls, FlyControls } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame, useLoader } from '@react-three/fiber'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { SSAOPass } from 'three/examples/jsm/postprocessing/SSAOPass'
import { BokehPass } from 'three/examples/jsm/postprocessing/BokehPass'
import { Stairs, Road } from './ParticleSystems';
import { Fog } from 'three';

// import { EffectComposer, Bloom, DepthOfField, Noise, Vignette } from '@react-three/postprocessing';

extend({ EffectComposer, RenderPass, UnrealBloomPass, SSAOPass, BokehPass });


function Effect({ down }) {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  const params = useMemo(() => ({ focus: 50, aperture: 0.05, maxblur: 0.1 }), [])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current.render(), 1)
  return (
    <>
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      {/* <sSAOPass attachArray="passes" args={[scene, camera, 1024, 1024]} kernelRadius={5.8} maxDistance={5.4} /> */}
      <unrealBloomPass attachArray="passes" args={[aspect, 1, 0.5, 0]} />
    </effectComposer>
    </>
  )
}

// function Effect() {
//   // const [focus, setFocus] = useState(0);
//   let focus = 0;

//   useFrame(({clock, camera}) => {
//     focus = camera.position.distanceTo(new THREE.Vector3(0,0,0));
//   })

//   return(
//   <EffectComposer autoClear={false} renderPriority={-1}>
//     <DepthOfField focusDistance={focus} focalLength={0.02} bokehScale={10} height={480} />
//     {/* <Bloom luminanceThreshold={0.5} luminanceSmoothing={0.9} height={300} /> */}
//     <Noise opacity={0.2} />
//     <Vignette eskil={false} offset={0.1} darkness={1.5} />
//   </EffectComposer>
//   );
// }



const params = new URLSearchParams(window.location.search);
const viewer = params.get('viewer');
let viewerIsOwner = false;
let objkt = parseInt(params.get("objkt"), 10);

const query = `
query Objkt($id: bigint!) {
  hic_et_nunc_token_by_pk(id: $id) {
    token_holders(where: {quantity: {_gt: "0"}}, order_by: {id: asc}) {
      quantity
      holder {
        address
        name
      }
    }
  }
}
`;


async function fetchGraphQL(operationsDoc, operationName, variables) {
  const result = await fetch(
    "https://api.hicdex.com/v1/graphql",
    {
      method: "POST",
      body: JSON.stringify({
        query: operationsDoc,
        variables: variables,
        operationName: operationName
      })
    }
  );

  return await result.json();
}

async function doFetch() {
  if(!objkt) return;
  const { errors, data } = await fetchGraphQL(query, "Objkt", {"id":objkt});
  if (errors) {
    console.error(errors);
  }
  else 
  {
    const result = data.hic_et_nunc_token_by_pk;
    console.log({ result });
    return result;
  }
}

function checkViewerIsOwner(data) {
  if(!data || !data.token_holders) return;
  if (data.token_holders.some((e) => e.holder.address === viewer)) {
    console.log(`viewer IS owner`);
    viewerIsOwner = true;
  } else {
    console.log(`viewer is NOT owner`);
  }
  //console.log({ OBJKT: data });
}

function changeData(data, id) {
  let characters = [];
  console.log("Refreshing");
  if(!data || !data.token_holders) return;
  curData = curData.concat(data.token_holders.map((holder) => { return holder.holder.name ? holder.holder.name : 
    holder.holder.address.substr(0,4) + "..." + holder.holder.address.substr(-4);}));
  for (let i = curData.length - 1; i > data.length * id; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [curData[i], curData[j]] = [curData[j], curData[i]];
  }
  
  for(let i=0; i < curData.length; i++)
  {
    characters.push([(i % 8) * 2 - 7.5 + Math.random(), 18]);
  }
  
  console.log(curData)
  return characters;
}

// let data = doFetch();

let models = [], count = 0, curData=[];
for(let i=0; i < 10; i++)
{
  for(let j=0; j < 9; j++)
  {
    models[count++] = [i, j];
  }
}


function Sphere({pos}) {
  return <mesh position={pos}>
           <sphereGeometry args={[1,16,16]} />
           <meshStandardMaterial color={'purple'}/>
         </mesh>
}


function Trails() {
  
    const { scene, camera, gl } = useThree();
    camera.near = 0.01;
    camera.far = 10000;
    camera.updateProjectionMatrix();
    gl.autoClearColor = false;


    var fadeMaterial = new THREE.MeshBasicMaterial({
        color: 0x000000,
        transparent: true,
        opacity: 0.1
    });
    var fadePlane = new THREE.PlaneBufferGeometry(100, 100);
    var fadeMesh = new THREE.Mesh(fadePlane, fadeMaterial);

    if(camera.children.length === 0) {
        camera.add(fadeMesh);
        scene.add(camera);
        
    }

    fadeMesh.position.set(0,0,-1);
    fadeMesh.rotation.set(0, 0, Math.PI / 2);

    fadeMesh.renderOrder = 1;
  return null;
}


function Canyon() {
  
  let ref = useRef();
  let texture = useLoader(THREE.TextureLoader, "bump.jpg");
  let texture2 = useLoader(THREE.TextureLoader, "roughness.jpg");
  let texture3 = useLoader(THREE.TextureLoader, "noise.png");
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(0.005,0.005);
  texture2.wrapS = THREE.RepeatWrapping;
  texture2.wrapT = THREE.RepeatWrapping;
  texture2.repeat.set(0.05,0.05);
  texture3.wrapS = THREE.RepeatWrapping;
  texture3.wrapT = THREE.RepeatWrapping;
  texture3.repeat.set(0.0005,0.0005);

  useEffect(() => {

    const shape = new THREE.Shape();
    const shape2 = new THREE.Shape();
    shape.moveTo( 0,0 );
    shape2.moveTo( 0,0 );
    let p = [0,0], maxim = 0;
    for(let i = 0; i < 1000; i++) {
      p[0] += (Math.random() - 0.5) * 20;
      p[1] += (Math.random() + 0.5) * 5;
      if(Math.abs(p[0]) > maxim) maxim = Math.abs(p[0]);
      shape.lineTo( ...p );

      p[0] += (Math.random() - 0.5) * 10;
      shape2.lineTo( ...p );
    }
    
    shape.lineTo(-10000, 1000 * 5);
    shape.lineTo(-10000, 0);
    shape.lineTo( 0, 0 );

    shape2.lineTo(10000, 1000 * 5);
    shape2.lineTo(10000, 0);
    shape2.lineTo( 0, 0 );

    const extrudeSettings = {
      steps: 1,
      depth: 1000,
      bevelEnabled: true,
      bevelThickness: 2,
      bevelSize: 5,
      bevelOffset: 0,
      bevelSegments: 1
    };

    const geometryTop = new THREE.ExtrudeGeometry( shape, extrudeSettings );
    const geometryBottom = new THREE.ExtrudeGeometry( shape2, extrudeSettings );
    const materialTop = new THREE.MeshStandardMaterial( { bumpMap: texture, bumpScale: 10 } );
    const mesh = new THREE.Mesh( geometryTop, materialTop );
    mesh.position.set(0, 0,-2500);
    mesh.rotation.set(Math.PI / 2, 0, 0);
    const mesh2 = new THREE.Mesh( geometryBottom, materialTop );
    mesh2.rotation.set(Math.PI / 2, 0, 0);
    mesh2.position.set(50, 0,-2500);
    ref.current?.add(mesh);
    ref.current?.add(mesh2);


    // const copy1 = mesh.clone();
    // copy1.rotation.set(Math.PI / 2, 0, 0);
    // copy1.position.set(0, 1300, 0);
    // const copy2 = mesh2.clone();
    // copy2.rotation.set(Math.PI / 2, 0, 0);
    // copy2.position.set(50, 1300, 0);

    // ref.current?.add(copy1);
    // ref.current?.add(copy2);
  },[ref]);
  

  return <group ref={ref}></group>
}

function Ground() {
  let texture = useLoader(THREE.TextureLoader, "bump.jpg");
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(100,100)
  return (
  <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0,4,0]}>
    <planeGeometry args={[10000, 10000]} />
    <meshStandardMaterial bumpMap={texture} bumpScale={10} side={THREE.DoubleSide}/>
  </mesh>);
}

function Lights() {
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();

  useFrame(({camera}) => {
    ref1.current.position.copy(camera.position.clone().add(new THREE.Vector3(0, -50, 100)));
    ref2.current.position.copy(camera.position.clone().add(new THREE.Vector3(0, 450, 300)));
    ref3.current.position.copy(camera.position.clone());
    ref1.current.position.y = -100;
    ref2.current.position.y = 500;
  })

  return (
  <>
    <pointLight ref={ref1} position={[0,-20,100]} intensity={0.5} color={'white'} distance={350}/>
    <pointLight ref={ref2} position={[0,450,100]} intensity={0.5} color={'white'} distance={350}/>
    <pointLight ref={ref3} position={[0,450,100]} intensity={0.1} color={'white'} distance={50}/>
  </>)
}

function Constraints() {
  const {camera} = useThree();
  useEffect(() => {
    camera.position.set(0,50,0);
    camera.lookAt(0,50, -10);
  })
  useFrame(() => {
    if(camera.position.y < 5) camera.position.y += 0.2;
  })
  return null;
}

function App() {
  const [id, setId] = useState(0);
  const [characters, set] = useState([]);

  useEffect(() => {
    // doFetch(objkt)
    //   .then((data) => changeData(data, id))
    //   .then((char) => set(char));
  }, [id])


  return (
    <div id="wrapper" onMouseDown={() => {console.log("PRESSED")}}>
  <Canvas>
    <fog args={["white"]} />
    <Effect />
    <color attach="background" args={["black"]} />
      <ambientLight intensity = {0.02} />
      <Lights />
      <Suspense fallback={null}>
        <Canyon />
        {/* <Ground /> */}
        <Stairs count={10000}/>
        <Trails />
      </Suspense>
    {/* <OrbitControls />  */}
    <Constraints />
    <FirstPersonControls lookSpeed={0.1} movementSpeed={50} heightMax={1} heightCoef={0}/>
    {/* <Stats /> */}
  </Canvas>
  </div>
  );
}

export default App;
